import React from "react";

const News = ({ news }) => {
  return (
    <li key={news.id} className="mr-5">
      <a className="notification-text" href={news.newsLink} target="_blank">
        {news.titleEn}
      </a>
    </li>
  );
};

export default News;
